// @flow
export const COOKIE_POLICY_MODULE_NAME = 'cookiePolicy';
